import axios from 'axios';
import store from '../store';
import router from '../router';
import Vue from 'vue';

export default () => {
  const api = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}/api/v2`,
  });
    // request setting
  api.interceptors.request.use((config) => {
    config.headers.Authorization = (`Bearer ${store.getters['tentacle/token']}`);
    config.headers.Accept = '*/*';
    return config;
  });
  // response setting
  api.interceptors.response.use(response => response,
    (error) => {
      const originalRequest = error.config;
      if (error.response.status && error.response.status === 401) {
      // try to refresh token
        if (error.response.data.message === 'Expired JWT Token') {
          return axios.post(`${process.env.VUE_APP_API_URL}/api/v2/auth/refresh`,
            { refresh_token: store.getters['tentacle/refreshToken'] })
            .then((res) => {
              if (res.status === 200) {
              // 1) put token to LocalStorage
                const user = store.getters['tentacle/user'];
                user.token = res.data.token;
                user.refresh_token = res.data.refresh_token;
                store.commit('tentacle/SET_USER', user);

                // 2) Change Authorization header
                const retryOriginalRequest = new Promise((resolve) => {
                  originalRequest.headers.Authorization = `Bearer ${user.token}`;
                  resolve(axios(originalRequest));
                });

                // 3) return originalRequest object with Axios.
                return retryOriginalRequest;
              }
            }, (error2) => {
              // 4) expired refresh token
              store.dispatch('tentacle/setLogout');
              router.push({ name: 'login' });
              return error2.response;
            });
        } else if (error.response.data.message === 'An authentication exception occurred.') {
          Vue.prototype.$flashStorage.flash('Current user is not a customer!', 'error');
        }
        // 5) wrong login credentials
        store.dispatch('tentacle/setLogout');
        router.push({ name: 'login' });
      } else if (error.response.status && error.response.status === 403) {
      // placeholder for future handling error 403
      }
      return error.response;
    })
  ;
  // return API object
  return api;
};
